import { h, Component } from 'preact';
import { Howl, Howler } from 'howler';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';
import s from 'components/bolt/audio/audio.sss';

export default class Audio extends Component {
	constructor(props) {
		super(props);
		this.playSound = this.playSound.bind(this);
		this.state = {
			muted: false
		};
	}

	componentDidMount() {
		const { audioRoot } = this.props;
		const soundEffects = [
			'yJAKq905A',
			'q6AQCnq9X',
			'8XCwXP59D',
			'BhgKd4WbX',
			'y1dRIRdC8',
			'atElRkoyt',
			'5DeUe41lk',
			'pHhwZf5l2',
			'zNkMmvLfL',
			'hFliKhSph',
			'klTdyNco6',
			'd0IiSPYzI',
			'F9GKvqoMx',
			'Kfudon4oi',
			'GQ4eJ287r',
			'P312b6J9x',
			'jugLyD3g2',
			'IXlmhXsOM',
			'n2HWHftJE',
			'SXgybFGB9',
			'idoQrBNKy',
			'3RyQcISHk'
		];
		soundEffects.forEach(sound => {
			this[sound] = new Howl({
				src: `${audioRoot}/${sound}.mp3`
			});
		});

		Store.on('PLAY_SOUND', this.playSound);
	}

	componentWillUnmount() {
		Store.off('PLAY_SOUND', this.playSound);
	}

	playSound(sound) {
		this[sound].play();
	}

	toggleMute(mute) {
		Howler.mute(mute);
		this.setState({
			muted: mute
		});
	}

	render({ sharedImageRoot }) {
		const { muted } = this.state;
		return (
			<div class={s.container}>
				<button class={joinClasses(s.muted, !muted && s.hide)} onClick={() => this.toggleMute(false)}>
					<img src={`${sharedImageRoot}/icons/muted.png`} />
				</button>
				<button class={joinClasses(s.soundOn, muted && s.hide)} onClick={() => this.toggleMute(true)}>
					<img src={`${sharedImageRoot}/icons/soundon.png`} />
				</button>
			</div>
		);
	}
}